import React, { FC } from 'react';
interface IProps {
  className?: string;
  color?: string;
}
const IconKanbanUser: FC<IProps> = ({ className, color = null }) => {
  return (
    <>
      <svg
        className={className}
        xmlns="http://www.w3.org/2000/svg"
        version="1.0"
        viewBox="0 0 256.000000 256.000000"
        preserveAspectRatio="xMidYMid meet"
      >
        <g
          transform="translate(0.000000,256.000000) scale(0.100000,-0.100000)"
          fill={color ?? '#777777'}
          stroke="none"
        >
          <path d="M1140 2384 c-177 -38 -348 -171 -429 -334 -99 -203 -92 -428 21 -617 35 -59 120 -152 177 -194 l35 -25 -47 -23 c-183 -89 -340 -251 -422 -437 -51 -115 -67 -197 -72 -376 l-6 -166 26 -26 26 -26 831 0 831 0 26 26 26 26 -6 166 c-7 225 -41 347 -142 503 -83 128 -239 264 -363 316 l-37 15 35 26 c157 116 256 296 267 487 24 421 -362 749 -777 659z m255 -159 c256 -67 415 -329 350 -578 -67 -258 -329 -417 -578 -352 -257 67 -417 329 -352 578 67 258 329 417 580 352z m97 -1138 c117 -37 203 -90 294 -181 136 -137 201 -282 211 -478 l6 -108 -723 0 -723 0 6 108 c10 196 75 341 211 478 110 110 236 177 381 204 86 16 251 5 337 -23z" />
          <path d="M1065 615 c-16 -15 -25 -36 -25 -55 0 -19 9 -40 25 -55 24 -25 26 -25 215 -25 189 0 191 0 215 25 16 15 25 36 25 55 0 19 -9 40 -25 55 -24 25 -26 25 -215 25 -189 0 -191 0 -215 -25z" />
        </g>
      </svg>
    </>
  );
};
export default IconKanbanUser;
